import type { Metric } from 'web-vitals';

import { afterSettle } from '@/afterSettle';
import { reportVital, sentryEnabled } from '@/sentry';

export const VITALS_SAMPLE_RATE = 0.1;

export function routePattern(hash: string): string {
  const path = hash.replace(/^#/, '').split(/[?&]/)[0];
  if (!path.startsWith('/')) return '/';
  return path
    .split('/')
    .map((segment, i) => (i > 1 && /\d/.test(segment) ? ':id' : segment))
    .join('/');
}

export function startVitals(sample: number = Math.random()): void {
  if (!sentryEnabled || sample >= VITALS_SAMPLE_RATE) return;
  const startRoute = routePattern(window.location.hash);
  afterSettle(() => {
    import('web-vitals').then(
      ({ onCLS, onINP, onLCP }) => {
        const send = (route: () => string) => (m: Metric) =>
          reportVital({ name: m.name, value: m.value, rating: m.rating, route: route() });
        const current = () => routePattern(window.location.hash);
        onLCP(send(() => startRoute));
        onINP(send(current));
        onCLS(send(current));
      },
      () => {},
    );
  });
}
